var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m211.57 96h776.87c36.926 0 56.723 43.414 32.531 71.293l-312.97 360.71v108l-212.11 141.41c-1.668 1.1055-3.8867-0.082031-3.8867-2.0742v-247.33l-312.96-360.71c-24.203-27.879-4.3906-71.293 32.531-71.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m708 1008c0 53.016-48.348 96-108 96s-108-42.984-108-96 108-192 108-192 108 138.98 108 192z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasting);
export default __webpack_public_path__ + "static/media/casting.e11c50ce183c170e39a14703be4f225b.svg";
export { ForwardRef as ReactComponent };